import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import DiscountBanner from "./DiscountBanner";
import SiteBackdrop from "./SiteBackdrop";

// Frame for the public marketing pages (home, pricing, legal, share pages).
// Gameplay screens don't use it. RTL and the Cairo font are set here rather
// than on <html> so the game screens keep their own layout.
const PublicLayout = ({ children }) => {
  const { pathname, hash } = useLocation();

  // Router links don't scroll: jump to #section links, else to the top.
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div
      dir="rtl"
      className="relative isolate min-h-screen flex flex-col overflow-x-clip bg-header font-sans text-white"
    >
      <SiteBackdrop />
      <SiteHeader />
      <DiscountBanner />
      <main className="relative flex-1">{children ?? <Outlet />}</main>
      <SiteFooter />
    </div>
  );
};

export default PublicLayout;
